import styled from 'styled-components';

import { body, heading } from '@constants/fonts';

export const NotesWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.divider};
  display: inline-block;
  border-radius: 7px;
  box-shadow: ${({ theme }) => theme.shadows[24]};
  min-width: 300px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-sizing: border-box;
  overflow: hidden;

  h2 {
    font-size: 14px;
    padding: 15px 25px;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
    font-family: ${heading};
    font-weight: 500;
    letter-spacing: 0.32px;
    text-transform: uppercase;
  }

  p {
    overflow-wrap: break-word;
    margin: 0;
    clear: both;
  }

  span {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 14px;
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    max-width: 80%;
  }
`;

export const Note = styled.div`
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.palette.common.accentLightblue};
  padding: 10px 20px 10px 25px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  &:first-of-type {
    padding-top: 15px;
  }

  &:last-of-type {
    border-bottom: 0;
  }

  h4 {
    margin: 0;
  }
`;

export const NoteTitle = styled.h4`
  text-transform: none;
  font-weight: 600;
`;

export const Remove = styled.span`
  text-align: right;
  user-select: none;
  float: right;
  width: 10px;
  height: 10px;
  margin-top: 2px;
  opacity: 1;
  transition: opacity 0.3s ease-out;

  &:hover {
    opacity: 0.2;
  }
`;

export const Button = styled.button`
  box-sizing: border-box;
  padding: 14px 60px;
  border-radius: 35px;
  border: 1.5px solid ${({ theme }) => theme.palette.primary.main};
  background-color: ${(props) =>
    props.disabled ? 'transparent' : props.theme.palette.background.paper};
  border: ${(props) =>
    props.disabled ? `1px solid ${props.theme.palette.primary.main}` : 'none'};
  box-shadow: ${(props) =>
    props.disabled ? 'none' : `${props.theme.shadows[4]}`};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.main};
  display: inline-block;
  cursor: pointer;
  transition: background-color 0.2s;
  font-family: ${body};
  font-size: 14px;
  letter-spacing: 0.3px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.common.accentLightblue};
    user-select: none;
  }
`;
